module.exports = __webpack_public_path__ + "img/icon-song-2.780c7a81.png";